// extracted by mini-css-extract-plugin
module.exports = {"root":"BrowserHint_root__1Goyd","bubble":"BrowserHint_bubble__Uwm7c"};